import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { injectCompanyProductFromDetail } from '../company-product-detail.component';

@Component({
  selector: 'app-company-product-page-identity',
  templateUrl: './company-product-page-identity.component.html',
  styleUrls: ['./company-product-page-identity.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-visible]': 'company_product() !== null',
  },
})
export class CompanyProductPageIdentityComponent {
  readonly company_product = injectCompanyProductFromDetail();
}
